import React from "react"
import { FormattedMessage, injectIntl } from "react-intl"
import { OnlinePaymentReceipt } from "../state/helpers/OnlinePaymentReceipt"
import { ExternalPaymentTypesMapping } from "./externalpaymenttypesmapping.jsx"

type OwnProps = {
    pay: OnlinePaymentReceipt,
}

const ExternalCheckoutDetailsComponent = (props: OwnProps) => {
    const { pay } = props

    const getExternalCheckoutPaymentType = () => {
        if (pay.paymentType !== "external-checkout") {
            return pay.paymentType
        }

        return pay.externalCheckoutDetails.attributes.paymentType
    }

    return (
        <div className="px-3" style={{ width: "23%" }}>
            <p className="mb-1 border-bottom">
                <small>
                    <FormattedMessage
                        id="payment.payment_method"
                        defaultMessage="Payment method"
                    />
                </small>
            </p>
            {
                pay.creditCardDetails ?
                    <>
                        <pre className="mb-0">
                            {pay.creditCardDetails.attributes.brand.toUpperCase()}
                        </pre>
                        <pre className="mb-0">
                            {pay.creditCardDetails.attributes.cardHolderName}
                        </pre>
                        <pre className="mb-0">
                            **** **** **** {pay.creditCardDetails.attributes.last4}
                        </pre>
                        <pre className="mb-0">
                            {pay.creditCardDetails.attributes.expirationMonth}
                            &nbsp;/&nbsp;
                            {pay.creditCardDetails.attributes.expirationYear}
                        </pre>
                    </> :
                    <pre>
                        {ExternalPaymentTypesMapping[getExternalCheckoutPaymentType()]}
                    </pre>
            }
        </div>
    )
}

export default injectIntl(ExternalCheckoutDetailsComponent)


// WEBPACK FOOTER //
// ./src/payment/ExternalCheckoutDetailsComponent.tsx